<template>
  <div class="error-page">
    <h1 class="error-page__headline">
      {{ error.statusCode }}: {{ error.statusMessage }}
    </h1>
    <span class="error-page__message">
      {{ error.statusMessage }}
    </span>
    <nuxt-link to="/">
      Go back home
    </nuxt-link>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError
});
</script>

<style lang="scss">
.error-page {

}
</style>
